/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  // Space,
  Tooltip,
  Typography,
  // DatePicker,
  Switch,
  AutoComplete,
  Select,
  Radio,
  Upload,
  Image,
  Skeleton,
} from "antd";
import qrCodeLogo from "../../assets/images/barcode-placeholder.svg";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  SettingOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  PlusCircleFilled,
  // DownOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { PiBarcodeBold } from "react-icons/pi";
import { isEmpty, isUndefined } from "lodash";
import { Prompt, useHistory } from "react-router-dom";
import moment from "moment";
import { BiCalendar, BiQrScan } from "react-icons/bi";
import axios from "axios";
import CreateItems from "../Items/items";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import {
  createPartyVendorAddress,
  createPurchaseList,
  loadPartyVendorAddress,
  loadPurchaseOrders,
  loadPurchaseRecordsMetaData,
  updatePurchaseList,
  // updatePurchaseList,
} from "../../store/purchase-orders/actions";
import {
  createVendorList,
  loadVendor,
  updateVendorList,
} from "../../store/vendor/actions";
import {
  createCategoryList,
  loadCategory,
  loadItems,
} from "../../store/items/actions";
import "react-datepicker/dist/react-datepicker.css";
import { loadFinancialYearList } from "../../store/expenses/actions";

const CreatePurchaseOrders = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //initial loading states
  const [additionalOptions, setAdditionalOptions] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [partyMode, setPartyMode] = useState("");
  const [autoRoundOffMethod, setAutoRoundOffMethod] = useState([]);
  const [poDate, setPoDate] = useState("");
  const [poNo, setPoNo] = useState("");
  const [validDate, setValidDate] = useState("");
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const organizationName = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationName
    : "";
  const poNoValue =
    props && !isEmpty(props.state) && props.state ? props.state : "1";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const purchaseList = { organizationId: organizationId };

  const updatedData =
    props.location && props.location.state
      ? props.location.state.purchaseData
      : "";

  //Initial load

  const poDateValue = moment().format("YYYY-MM-DD");
  const validDateValue = moment().add(1, "month").format("YYYY-MM-DD");
  console.log(poDateValue, "poDateValue");
  useEffect(() => {
    setAdditionalOptions({
      value: "No Tax Applicable",
      label: "No Tax Applicable",
    });
    setDiscount({
      value: "Display After Tax",
      label: "Display After Tax",
    });
    setAutoRoundOffMethod({
      value: "add",
      label: "+ Add",
    });
    if (poNoValue) {
      setPoNo(poNoValue);
    }
    setPoDate(poDateValue);
    setValidDate(validDateValue);
    dispatch(loadFinancialYearList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log(poDateValue, "poDateValue")
  // console.log(validDateValue, "validDateValue")

  const handlePoDateChange = (date) => {
    setPoDate(date);
  };
  const handleValidDateChange = (date) => {
    setValidDate(date);
  };

  //reducer state
  const { vendor_list = [] } = useSelector((state) => state.Vendor);
  const { financial_year_list = [] } = useSelector((state) => state.Expenses);
  const { recordsMetaData = {}, party_address_list = [] } = useSelector(
    (state) => state.PurchaseOrders
  );

  //Reducer state
  const {
    items_list = [],
    category_list = [],
    // recordsMetaData = {},
  } = useSelector((state) => state.Items);

  const categoryOptions =
    category_list.length > 0
      ? category_list.map((c) => {
          return {
            label: c.categoryName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];

  const financialyearId =
    financial_year_list && financial_year_list.length > 0
      ? financial_year_list[0]._id
      : "";

  //create party modal states

  const [partyAddressData, setPartyAddressData] = useState([
    {
      address1: "",
      city: "",
      country: "",
      pincode: "",
      state: "",
      stateName: "",
      _id: "",
    },
  ]);

  const [partyModalData, setPartyModalData] = useState({
    mobile: "",
    vendorName: "",
    cityName: "",
    gstIn: "",
    billingAddress: "",
    totalAddress: "",
    state: "",
    billingCityName: "",
    billingAddressValue: "",
    totalBillingAddress: "",
    billingState: "",
    vendorId: "",
    _id: "",
  });

  const handleModalChange = (e) => {
    setPartyModalData({
      ...partyModalData,
      [e.target.name]: e.target.value,
    });
  };

  const [newShippingData, setNewShippingData] = useState({
    cityName: "",
    billingAddress: "",
    totalAddress: "",
    state: "",
    _id: "",
  });

  const handleShippingModalChange = (e) => {
    setNewShippingData({
      ...newShippingData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (party_address_list && party_address_list.length > 0) {
      setPartyAddressData(party_address_list);
    }
  }, [party_address_list]);

  //party vendor state modal section
  const [partyCheckedId, setPartyCheckedId] = useState("");
  const [sameAs, setSameAs] = useState("");
  const [stateData, setStateData] = useState([]);
  const [pincode, setPincode] = useState("");
  const [shippingState, setShippingState] = useState([]);
  const [shippingPincode, setShippingPincode] = useState("");
  const [billingStateData, setBillingStateData] = useState([]);
  const [billingPincode, setBillingPincode] = useState("");
  const [partyModal, setPartyModal] = useState(false);
  const [createPartyModal, setCreatePartyModal] = useState(false);
  const [createShippingModal, setCreateShippingModal] = useState(false);
  const [createNewShippingModal, setCreateNewShippingModal] = useState(false);
  const [addAddressShow, setAddAddressShow] = useState(false);
  const [addGstShow, setAddGstShow] = useState(false);

  //Billing modal
  const billingAddressSubmit = () => {
    if (isEmpty(newShippingData.billingAddress)) {
      toast.error("Enter the street address field");
    } else {
      const partyAddress = {
        organizationId: organizationId,
        partyOrVendorId: partyModalData._id,
        shippingAddress: {
          address1: newShippingData.billingAddress,
          // "address2": "Near SVR",
          country: "India",
          state: shippingState,
          pincode: shippingPincode,
          city: newShippingData.cityName,
        },
      };

      dispatch(createPartyVendorAddress(partyAddress));

      setTimeout(() => {
        dispatch(
          loadPartyVendorAddress({
            organizationId: organizationId,
            partyorvendorId: partyModalData._id,
          })
        );
        setCreateNewShippingModal(false);
      }, 1500);
    }
  };

  //parties rows
  const [vendorRows, setVendorRows] = useState([
    {
      vendorName: "",
      vendorNameValue: "",
      partyCode: "",
      billingAddress: [],
      shippingAddress: [],
      openingbalanceType: "",
      _id: "",
      state: "",
      currentBalance: "",
      status: "",
    },
  ]);

  const vendorDataTable =
    vendor_list && vendor_list.length > 0
      ? vendor_list.map((data, index) => {
          return {
            index: index + 1,
            billingAddress: data.billingAddress,
            shippingAddress: data.shippingAddress,
            _id: data._id,
            creditBalance: data.creditBalance,
            currentBalance: data.currentBalance,
            openingbalanceType: data.openingbalanceType,
            vendorName: data.vendorName ? data.vendorName : "--",
            creditLimit: data.creditLimit ? data.creditLimit : "--",
            displayName: data.displayName ? data.displayName : "--",
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (vendorDataTable && vendorDataTable.length > 0) {
      setVendorRows(vendorDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor_list]);

  //data table
  const [search, setSearch] = useState("");
  const [tableLoading, setTableLoading] = useState(false);

  const handleSearch = (event) => {
    const filteredRows = vendorDataTable
      .filter((row) =>
        row.vendorName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setVendorRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const purchasePartyData = {
    organizationId: organizationId,
    vendorName: partyModalData.vendorName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddress,
        // address2: "Suite 456",
        country: "India",
        state: stateData,
        pincode: pincode,
        city: partyModalData.cityName,
      },
    ],
    shippingAddress:
      sameAs === true
        ? [
            {
              address1: partyModalData.billingAddressValue,
              // address2: "Suite 456",
              country: "India",
              state: billingStateData,
              pincode: billingPincode,
              city: partyModalData.billingCityName,
            },
          ]
        : [
            {
              address1: partyModalData.billingAddress,
              // address2: "Suite 456",
              country: "India",
              state: stateData,
              pincode: pincode,
              city: partyModalData.cityName,
            },
          ],
    createdBy: userId,
  };

  const purchasePartyObj = Object.keys(purchasePartyData).forEach(
    (k) => !purchasePartyData[k] && delete purchasePartyData[k]
  );
  const purchaseUpdatePartyData = {
    vendorId: partyModalData._id,
    organizationId: organizationId,
    vendorName: partyModalData.vendorName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddressValue,
        // address2: "Suite 456",
        country: "India",
        state: billingStateData,
        pincode: billingPincode,
        city: partyModalData.billingCityName,
      },
    ],
    shippingAddress:
      sameAs === true
        ? [
            {
              address1: partyModalData.billingAddress,
              // address2: "Suite 456",
              country: "India",
              state: !isEmpty(partyModalData.state)
                ? partyModalData.state
                : stateData,
              pincode: pincode,
              city: partyModalData.cityName,
            },
          ]
        : [
            {
              address1: partyModalData.billingAddressValue,
              // address2: "Suite 456",
              country: "India",
              state: billingStateData,
              pincode: billingPincode,
              city: partyModalData.billingCityName,
            },
          ],
    createdBy: userId,
  };

  const purchaseUpdatePartyObj = Object.keys(purchaseUpdatePartyData).forEach(
    (k) => !purchaseUpdatePartyData[k] && delete purchaseUpdatePartyData[k]
  );

  console.log(purchasePartyObj, "purchasePartyObj");
  console.log(purchaseUpdatePartyObj, "purchaseUpdatePartyObj");

  //create items list
  const createVendorApi = () => {
    if (simpleValidator.current.allValid()) {
      dispatch(createVendorList(purchasePartyData));

      setTimeout(() => {
        dispatch(loadVendor(purchaseList));
        toast.success("Vendor Added Successfully");
        setCreatePartyModal(false);
      }, 2000);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };
  //create items list
  const updateVendorApi = () => {
    if (simpleValidator.current.allValid()) {
      dispatch(updateVendorList(purchaseUpdatePartyData));

      setTimeout(() => {
        dispatch(loadVendor(purchaseList));
        toast.success("Vendor Updated Successfully");
        setCreatePartyModal(false);
      }, 2000);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //purchase State values
  const [columnSettings, setColumnSettings] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [additionalChargesOpen, setAdditionalChargesOpen] = useState(false);
  const [discountOpen, setDiscountOpen] = useState(false);
  const [autoRoundOff, setAutoRoundOff] = useState(false);

  const [purchaseData, setPurchaseData] = useState({
    price: true,
    quantity: true,
    travel: true,
    batch: true,
    expiryDate: true,
    mfgDate: false,
  });
  const [notes, setNotes] = useState("");
  const [termsConditions, setTermsConditions] = useState("");

  const [totalSectionData, setTotalSectionData] = useState({
    chargesData: "",
    additionalCharges: "",
    discountPercent: "",
    discountAmount: "",
    autoRoundOffValue: "",
    amountPaid: "",
    totalAmount: "",
    tcsTaxName: "",
    tcsSectionName: "",
    tcsRatePercent: "",
    tdsTaxName: "",
    tdsSectionName: "",
    tdsRatePercent: "",
    chargeId: "",
  });

  const handlePurchaseChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      discountPercent: /^[0-9]\d*\.?\d*$/,
      discountAmount: /^\d*\.?\d*$/,
      autoRoundOffValue: /^\d*\.?\d*$/,
      totalAmount: /^\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setTotalSectionData({
          ...totalSectionData,
          [name]: value,
        });
      }
    } else {
      setTotalSectionData({
        ...totalSectionData,
        [name]: value,
      });
    }
  };

  // const handleDiscountChange = (e) => {
  //   const listData = totalSectionData;
  //   listData.discountPercent = parseInt(e.target.value * 100);

  //   setTotalSectionData(listData);
  // };

  //Item create modal
  const [itemModal, setItemModal] = useState(false);
  // const [purchaseItemSelect, setPurchaseItemSelect] = useState(false);
  const [createItemModal, setCreateItemModal] = useState(false);
  const [scanQrModal, setScanQrModal] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  // const [expandable, setExpandable] = useState(false);
  const [quantityShow, setQuantityShow] = useState(false);
  // const [quantityCount, setQuantityCount] = useState(false);
  const [quantityCountValue, setQuantityCountValue] = useState(0);
  // const [quantityCountId, setQuantityCountId] = useState("");
  const [pageRender, setPageRender] = useState(false);
  const [purchasePriceModal, setPurchasePriceModal] = useState(false);
  const [purchaseColumn, setPurchaseColumn] = useState(false);
  const [asOfDate, setAsOfDate] = useState("");
  const [batchingModal, setBatchingModal] = useState(false);

  //create category modal
  const [categoryName, setCategoryName] = useState("");
  const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");
  const [description, setDescription] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [renderPage, setRenderPage] = useState(false);

  const handleClose = (data) => {
    setCreateItemModal(data);
  };

  const [itemRows, setItemRows] = useState([
    {
      itemName: "",
      itemChecked: "",
      itemNameValue: "",
      itemDescription: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      discountPrice: "",
      discountPercentage: "",
      taxPercentageValue: "",
      taxValue: "",
      totalAmount: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      quantityCount: 0,
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      taxPercentageId: "",
      taxPercentageName: "",
      image: "",
      isProduct: "",
      hsnCode: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      serialMeasuringId: "",
      updatedAt: "",
      itemUpdateId: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const [itemSelectedRows, setItemSelectedRows] = useState([
    {
      itemName: "",
      itemChecked: "",
      itemNameValue: "",
      taxPercentageValue: "",
      itemDescription: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      discountPrice: "",
      discountPercentage: "",
      taxPercentage: "",
      taxValue: "",
      taxPercentageId: "",
      taxPercentageName: "",
      totalAmount: "",
      hsnCode: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      quantityCount: "",
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      image: "",
      isProduct: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      itemUpdateId: "",
      serialMeasuringId: "",
      updatedAt: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const itemsDataTable =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          const categoryName =
            categoryOptions && categoryOptions.length > 0
              ? categoryOptions.find(
                  (category) => category.value === data.categoryId
                )
              : "";

          const categoryNameValue = !isEmpty(categoryName)
            ? categoryName.label
            : "";
          return {
            index: index + 1,
            itemName: data.itemName,
            itemNameValue: data.itemName,
            itemChecked: "",
            taxPercentageValue: "",
            _id: data._id,
            itemCode: data.itemCode ? data.itemCode : "--",
            salesPrice: data.salesPrice ? data.salesPrice : "",
            purchasePrice: data.purchasePrice ? data.purchasePrice : "",
            stockQTY: data.noofStock ? data.noofStock : "--",
            quantityCount: 0,
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            categoryId: data.categoryId,
            itemUpdateId: "",
            categoryName: data.categoryName,
            categoryNameValue: categoryNameValue,
            taxPercentageId: data.gstPercentageId,
            taxPercentageName: data.gstPercentageName,
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            itemCodeValue: data.itemCode,
            salesPriceValue: data.salesPrice,
            purchasePriceValue: data.purchasePrice,
            stockQTYValue: data.noofStock,
            categoryIdValue: data.categoryId,
            hsnCode: data.hsnCode,
            descriptionValue: data.description,
            isProduct: data.isProduct,
            isService: data.isService,
            measuringId: data.measuringId,
            description: data.description,
            serialDetails: data.serialDetails,
            updatedAt: data.updatedAt,
            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemsDataTable && itemsDataTable.length > 0) {
      setItemRows(itemsDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items_list]);

  //handle item rows change
  const handleItemChange = (e, name, index, data) => {
    const itemList = itemRows;
    if (name == "itemChecked") {
      itemList[index][name] = e.target.checked;
      setItemRows(itemList);
      setRenderPage(!renderPage);

      const selectedIndex = itemSelectedRows.indexOf(data);
      let newSelecteds = [];
      if (e.target.checked === true) {
        if (selectedIndex === -1) {
          newSelecteds = newSelecteds.concat(itemSelectedRows, data);
        }
      } else {
        newSelecteds = newSelecteds.concat(itemSelectedRows.slice(0, -1));
      }

      const itemSelectedFilteredRows =
        newSelecteds && newSelecteds.length > 0
          ? newSelecteds.filter((data) => !isEmpty(data.itemName))
          : [];

      const itemSelectedArrays =
        newSelecteds &&
        itemSelectedFilteredRows &&
        itemSelectedFilteredRows.length > 0
          ? itemSelectedFilteredRows.map((data, index) => {
              const gstPercentage = data.taxPercentageName.replace(
                /^%|%$/g,
                ""
              );
              const totalPriceData =
                !isUndefined(data.quantityCount) && data.salesPrice
                  ? data.quantityCount * data.salesPrice
                  : isUndefined(data.quantityCount) && data.salesPrice
                  ? data.salesPrice
                  : 0;
              const totalSetAmountData = (totalPriceData * gstPercentage) / 100;
              const totalPrice = totalSetAmountData + totalPriceData;

              console.log(totalSetAmountData, "totalSetAmountData");
              //  data.quantityCount = parseInt(data.quantityCount + 1)
              return {
                index: index + 1,
                itemName: data.itemName,
                itemNameValue: data.itemName,
                itemChecked: "",
                _id: data._id,
                itemCode: data.itemCode ? data.itemCode : "--",
                salesPrice: data.salesPrice ? data.salesPrice : "",
                purchasePrice: data.purchasePrice ? data.purchasePrice : "",
                stockQTY: data.noofStock ? data.noofStock : "--",
                batchDetails: data.batchDetails,
                createdAt: data.createdAt,
                createdBy: data.createdBy,
                customFields: data.customFields,
                categoryId: data.categoryId,
                categoryName: data.categoryName,
                categoryNameValue: data.categoryName,
                taxPercentageId: data.taxPercentageId,
                taxPercentageName: data.taxPercentageName,
                taxPercentageValue: gstPercentage,
                serialMeasuringId: data.serialMeasuringId,
                serialMeasuringName: data.serialMeasuringName,
                image: data.image,
                itemCodeValue: data.itemCode,
                salesPriceValue: data.salesPrice,
                purchasePriceValue: data.purchasePrice,
                discountPrice: !isUndefined(data.discountPrice)
                  ? data.discountPrice
                  : 0,
                discountPercentage: !isUndefined(data.discountPercentage)
                  ? data.discountPercentage
                  : 0,
                taxPercentage: data.taxPercentage,
                taxValue: totalSetAmountData,
                totalAmount: totalPrice,
                quantityCount: data.quantityCount ? data.quantityCount : 1,
                categoryIdValue: data.categoryId,
                hsnCode: data.hsnCode,
                descriptionValue: data.description,
                isProduct: data.isProduct,
                isService: data.isService,
                measuringId: data.measuringId,
                description: data.description,
                serialDetails: data.serialDetails,
                updatedAt: data.updatedAt,
                status: data.status,
              };
            })
          : [];

      setItemSelectedRows(itemSelectedArrays);
    }
  };

  const removeItemsData = (index) => {
    const array = itemSelectedRows;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  //item Selected on change
  const itemSelectedChange = (e, name, index) => {
    var itemList = itemSelectedRows;
    if (name == "itemDescription") {
      e = e.target.value;
      itemList[index][name] = e;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "taxPercentageId") {
      const gstPercentage = itemList[index].taxPercentageName.replace(
        /^%|%$/g,
        ""
      );

      const totalAmount =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].salesPrice
          ? itemList[index].quantityCount * itemList[index].salesPrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].salesPrice
          ? itemList[index].salesPrice
          : isEmpty(itemList[index].salesPrice) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const totalSetAmountData = (totalAmount * gstPercentage) / 100;
      const totalSetAmount = totalSetAmountData + totalAmount;

      itemList[index]["taxPercentageId"] = e;
      itemList[index]["taxPercentageName"] = gstPercentage;
      itemList[index]["taxValue"] = totalSetAmountData;
      itemList[index]["totalAmount"] = totalSetAmount;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "salesPrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) && e
          ? itemList[index].quantityCount * e
          : isUndefined(itemList[index].quantityCount) && e
          ? e
          : isEmpty(e) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? (e * totalAmountData) / 100
          : 0;
      const discountPercentage =
        itemList[index].discountPercentage &&
        parseInt(itemList[index].discountPercentage)
          ? (e * 100) / totalAmountData
          : 0;

      const totalAmountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? parseInt(totalAmountData - discountPrice)
          : parseInt(totalAmountData);
      const totalSetAmountData =
        (parseInt(itemList[index].taxPercentageValue) * totalAmountData) / 100;

      console.log(totalAmountPrice, "totalAmountPrice");
      console.log(totalSetAmountData, "totalSetAmountData");
      const totalAmountDetails = totalSetAmountData
        ? totalAmountPrice + totalSetAmountData
        : totalAmountPrice;
      console.log(totalAmountDetails, "totalAmountDetails");
      itemList[index][name] = e;
      // itemList[index]["salesPrice"] = totalAmountData;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["totalAmount"] = totalAmountDetails;
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "quantityCount") {
      e = e.target.value;
      const totalAmountData =
        e && itemList[index].salesPrice
          ? e * itemList[index].salesPrice
          : isEmpty(e) && itemList[index].salesPrice
          ? itemList[index].salesPrice
          : isEmpty(itemList[index].salesPrice) && e
          ? e
          : 0;
      // const totalSetAmountData = parseInt(itemList[index].taxPercentageValue);
      const totalSetAmountData =
        (parseInt(itemList[index].taxPercentageValue) * totalAmountData) / 100;

      // console.log(totalAmountPrice, "totalAmountPrice")
      console.log(totalSetAmountData, "totalSetAmountData");

      const totalAmountDetails = totalSetAmountData
        ? totalAmountData + totalSetAmountData
        : totalAmountData;

      // const totalSetAmountData = parseInt(itemList[index].taxValue) * e;
      // const totalSetPercentageData = parseInt(itemList[index].taxPercentageValue) * e;

      // const totalTaxAmountDetails =
      // (totalAmountData * totalSetPercentageData) / 100

      // const totalAmountDetails =
      //   totalAmountData + totalTaxAmountDetails

      //   console.log(totalAmountData, "totalAmountData")
      //   console.log(totalTaxAmountDetails, "totalTaxAmountDetails")
      //   console.log(totalSetPercentageData, "totalSetPercentageData")

      const salesPrice = itemList[index].salesPrice;
      itemList[index][name] = e;
      itemList[index]["salesPrice"] = salesPrice;
      itemList[index]["totalAmount"] = totalAmountDetails;
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPercentage") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].salesPrice
          ? itemList[index].quantityCount * itemList[index].salesPrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].salesPrice
          ? itemList[index].salesPrice
          : isEmpty(itemList[index].salesPrice) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPrice = (e * totalAmountData) / 100;

      const totalAmount = totalAmountData - discountPrice;

      itemList[index][name] = e;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["totalAmount"] = totalAmount;
      // itemList[index]["taxValue"] = discountTaxValue;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].salesPrice
          ? itemList[index].quantityCount * itemList[index].salesPrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].salesPrice
          ? itemList[index].salesPrice
          : isEmpty(itemList[index].salesPrice) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;
      const discountPercentage = (e * 100) / itemList[index].totalAmount;

      const discountPrice = totalAmountData - e;
      // const discountPriceValue = parseInt(itemList[index].discountPrice);

      const taxValue = parseInt(itemList[index].taxPercentageValue);
      const taxValueFinal =
        e > 0
          ? (discountPrice * taxValue) / 100
          : (totalAmountData * taxValue) / 100;
      console.log(discountPrice, "discountPrice");
      console.log(taxValueFinal, "taxValueFinal");
      console.log(e, "discount price");
      // const totalAmount = e > 0 ? discountPrice : totalAmountData;

      const discountTaxValue =
        e > 0 ? taxValueFinal + discountPrice : totalAmountData + taxValueFinal;

      console.log(totalAmountData, "totalAmountData");
      console.log(discountPercentage, "discountPercentage");
      itemList[index][name] = e;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["totalAmount"] = discountTaxValue;
      itemList[index]["taxValue"] = e == 0 || !isEmpty(e) ? taxValueFinal : "";
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "totalAmount") {
      e = e.target.value;
      itemList[index][name] = e;
      // itemList[index][name] = e
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
  };

  console.log(itemSelectedRows, "itemSelectedRows");
  console.log(totalSectionData, "totalSectionData");

  const [itemSearch, setItemSearch] = useState("");
  const [itemCategoryModal, setItemCategoryModal] = useState(false);
  const handleItemSearch = (event) => {
    const filteredRows = itemsDataTable.filter((row) => {
      return row.itemNameValue.toLowerCase().includes(event.target.value);
    });
    setItemSearch(event.target.value);
    setItemRows(filteredRows);
    // setTableLoading(true);
    // setTimeout(() => {
    //   setTableLoading(false);
    // }, 2000);
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let salesPrice = 0;
    let discountPrice = 0;
    let totalAmount = 0;
    let taxValue = 0;

    rows.forEach((row) => {
      salesPrice += parseFloat(row.salesPrice) || 0;
      discountPrice += parseFloat(row.discountPrice) || 0;
      totalAmount += parseFloat(row.totalAmount) || 0;
      taxValue +=
        row.taxValue ||
        // ? parseFloat(row.taxValue * row.quantityCount)
        // : parseFloat(row.taxValue)
        0;
    });

    return { salesPrice, discountPrice, totalAmount, taxValue };
  };

  const [totals, setTotals] = React.useState({
    salesPrice: 0,
    discountPrice: 0,
    totalAmount: 0,
    taxValue: 0,
  });

  useEffect(() => {
    // if(itemSelected === true) {

    const newTotals = calculateTotals(itemSelectedRows);
    setTotals(newTotals);
    // }
  }, [itemSelectedRows, renderPage]);

  // const discountAmountValues = totalSectionData.discountAmount
  //   ? parseInt(totalSectionData.discountAmount)
  //   : "";

  //category api integrations
  const createCategory = () => {
    if (simpleValidator.current.allValid()) {
      const categoryList = {
        categoryName: categoryName,
        organizationId: organizationId,
        shortCode: shortCode,
        description: description,
        createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
      };

      dispatch(createCategoryList(categoryList));
      setTimeout(() => {
        dispatch(loadCategory(purchaseList));
        setItemCategoryModal(false);
        toast.success("Category Created Successfully");
      }, 1000);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //Serialisation
  const [serialOpenStock, setSerialOpenStock] = useState("");
  const [serialData, setSerialData] = useState([
    {
      serialNo: "",
    },
  ]);

  const addSerialData = () => {
    setSerialData([
      ...serialData,
      {
        serialNo: "",
      },
    ]);
    // setSerialDataAdd(true);
    setPageRender(!pageRender);
  };

  const removeSerialData = (index) => {
    const array = serialData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
        setSerialOpenStock(array.length);
      }
    }
    setPageRender(!pageRender);
  };

  const handleSerialDataChange = (e, name, index) => {
    var fieldList = serialData;
    if (name === "serialNo") {
      fieldList[index][name] = e.target.value;
      setSerialData(fieldList);

      // if (fieldList.length > 0 && !isEmpty(fieldList[0].serialNo)) {
      setSerialOpenStock(fieldList.length);
      // }
      setPageRender(!pageRender);
    }
  };

  //tds & tcs

  const [pageRouting, setPageRouting] = useState(false);

  //settings States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);

  const [purchaseSettings, setPurchaseSettings] = useState({
    prefix: "Prefix",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPurchaseSettings({
      ...purchaseSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleOk = () => {
    setSettingsFieldModal(false);
  };
  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //Image upload
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      // reader.onerror = (error) => reject(error);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleImageChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  //upload btn
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Add Signature
      </div>
    </button>
  );

  const roundOffFinalValues = !isEmpty(totalSectionData.autoRoundOffValue)
    ? parseInt(totalSectionData.autoRoundOffValue)
    : "";
  const additionalChargesFinalValues = totalSectionData.additionalCharges
    ? parseInt(totalSectionData.additionalCharges)
    : "";
  const dicountAmountValues = totalSectionData.discountAmount
    ? parseInt(totalSectionData.discountAmount)
    : "";
  //Po net amount
  const discountFinalAmount = parseInt(
    totals.totalAmount + additionalChargesFinalValues + roundOffFinalValues
  );
  const roundOffFinalWithTotal = parseInt(
    totals.totalAmount + roundOffFinalValues
  );

  const netAmount =
    itemSelectedRows &&
    itemSelectedRows.length > 0 &&
    isEmpty(totalSectionData.additionalCharges) &&
    // isEmpty(updatedData) &&
    isEmpty(totalSectionData.autoRoundOffValue) &&
    isEmpty(totalSectionData.discountAmount)
      ? totals.totalAmount
      : itemSelectedRows.length > 0 &&
        !isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        !isEmpty(totalSectionData.discountAmount)
      ? parseInt(discountFinalAmount - dicountAmountValues)
      : itemSelectedRows.length > 0 &&
        !isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? discountFinalAmount
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges > 0 &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? parseInt(totals.totalAmount + additionalChargesFinalValues)
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        totalSectionData.autoRoundOffValue &&
        isEmpty(totalSectionData.discountAmount)
      ? parseInt(totals.totalAmount + roundOffFinalValues)
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        !isEmpty(totalSectionData.discountAmount)
      ? parseInt(roundOffFinalWithTotal - dicountAmountValues)
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        !isEmpty(totalSectionData.discountAmount)
      ? parseInt(totals.totalAmount - dicountAmountValues)
      : 0;

  //   const netFinalAmountDiscount = itemSelectedRows.length > 0 &&
  //   isEmpty(totalSectionData.additionalCharges) &&
  //   !isEmpty(totalSectionData.autoRoundOffValue) &&
  //   !isEmpty(totalSectionData.discountAmount)
  // ? parseInt(roundOffFinalWithTotal - dicountAmountValues) : 0

  console.log(netAmount, "netAmount");
  //Po add api payloads
  const purchaseOrdersListData = {
    vendorId: partyModalData._id,
    organizationId: organizationId,
    financialyearId: financialyearId,
    vendorAddress: partyModalData.billingAddress,
    vendorName: partyModalData.vendorName,
    vendorPhone: partyModalData.mobile,
    // vendorEmail: partyModalData.,
    vendorCity: partyModalData.cityName,
    vendorStateId: partyModalData.state ? partyModalData.state : stateData,
    vendorPincode: pincode,
    poNo: poNo,
    poDate: poDate,
    povalidDate: validDate,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            return {
              itemId: data._id,
              itemName: data.itemName,
              hsn: data.hsnCode,
              qty: data.quantityCount,
              priceofitem: data.salesPrice,
              subtotal: data.totalAmount,
              discountpercentage: data.discountPercentage,
              discountValue: data.discountPrice,
              taxableValue: data.taxPercentage,
              // taxpercentage: 18,
              taxpercentageId: data.taxPercentageId,
              taxValue: data.taxValue,
              totalamount: data.totalAmount,
            };
          })
        : [],
    subtotalamount:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.totalAmount : 0,
    totaldiscount:
      itemSelectedRows && itemSelectedRows.length > 0
        ? totals.discountPrice
        : 0,
    totaltaxableValue:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.salesPrice : 0,
    totaltax:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.taxValue : 0,
    charge: [
      {
        chargeName:
          additionalOptions && !isEmpty(additionalOptions.value)
            ? additionalOptions.value
            : additionalOptions,
        chargeAmount: totalSectionData.additionalCharges,
        isGst: additionalOptions === "Tax Applicable" ? true : false,
        // gstPercentage: 18,
        // gstAmount: 18,
        // amountInclofTax: 118,
      },
    ],
    taxableAmonut: totals.salesPrice,
    beforeTax: discount === "Display Before Tax" ? true : false,
    discountPercentage: totalSectionData.discountPercent,
    discountAmount: totalSectionData.discountAmount,
    isautoOff: autoRoundOff,
    type:
      autoRoundOffMethod && !isEmpty(autoRoundOffMethod.value)
        ? autoRoundOffMethod.value
        : autoRoundOffMethod,
    autoamountroundoff: totalSectionData.autoRoundOffValue,
    NetAmount: netAmount,
    authorizedsignature:
      fileList && fileList.length > 0 ? fileList[0].name : "",
    notes: notes,
    termsandconditions: termsConditions,
    createdBy: userId,
    beforeautoroundoffamount: 0,
  };

  //update objects
  const purchaseUpdateOrdersListData = {
    poId: partyModalData._id,
    vendorId: partyModalData.vendorId,
    organizationId: organizationId,
    financialyearId: financialyearId,
    vendorAddress: partyModalData.billingAddress,
    vendorName: partyModalData.vendorName,
    vendorPhone: partyModalData.mobile,
    // vendorEmail: partyModalData.,
    vendorCity: partyModalData.cityName,
    vendorStateId: !isEmpty(updatedData) ? partyModalData.state : stateData,
    vendorPincode: pincode,
    poNo: poNo,
    poDate: poDate,
    povalidDate: validDate,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            return {
              itemId: data._id,
              itemName: data.itemName,
              hsn: data.hsnCode,
              qty: data.quantityCount,
              priceofitem: data.salesPrice,
              subtotal: data.totalAmount,
              discountpercentage: data.discountPercentage,
              discountValue: data.discountPrice,
              taxableValue: data.taxPercentage,
              // taxpercentage: 18,
              taxpercentageId: data.taxPercentageValue
                ? data.taxPercentageName
                : data.taxPercentageId,
              taxValue: data.taxValue,
              totalamount: data.totalAmount,
              _id: data.itemUpdateId,
            };
          })
        : [],
    subtotalamount:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.totalAmount : 0,
    totaldiscount:
      itemSelectedRows && itemSelectedRows.length > 0
        ? totals.discountPrice
        : 0,
    totaltaxableValue:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.salesPrice : 0,
    totaltax:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.taxValue : 0,
    charge: [
      {
        chargeName:
          additionalOptions && !isEmpty(additionalOptions.value)
            ? additionalOptions.value
            : additionalOptions,
        chargeAmount: totalSectionData.additionalCharges,
        isGst: additionalOptions === "Tax Applicable" ? true : false,
        _id: totalSectionData.chargeId,
        // gstPercentage: 18,
        // gstAmount: 18,
        // amountInclofTax: 118,
      },
    ],
    taxableAmonut: totals.salesPrice,
    beforeTax: discount === "Display Before Tax" ? true : false,
    discountPercentage: totalSectionData.discountPercent
      ? totalSectionData.discountPercent
      : 0,
    discountAmount: totalSectionData.discountAmount
      ? totalSectionData.discountAmount
      : 0,
    isautoOff: autoRoundOff,
    type:
      autoRoundOffMethod && !isEmpty(autoRoundOffMethod.value)
        ? autoRoundOffMethod.value
        : autoRoundOffMethod,
    autoamountroundoff: totalSectionData.autoRoundOffValue,
    NetAmount: netAmount,
    authorizedsignature:
      fileList && fileList.length > 0 ? fileList[0].name : "",
    notes: notes,
    termsandconditions: termsConditions,
    createdBy: userId,
    beforeautoroundoffamount: 0,
  };

  const purchaseOrdersList = Object.keys(purchaseOrdersListData).forEach(
    (k) => !purchaseOrdersListData[k] && delete purchaseOrdersListData[k]
  );
  const purchaseUpdateOrdersList = Object.keys(
    purchaseUpdateOrdersListData
  ).forEach(
    (k) =>
      !purchaseUpdateOrdersListData[k] && delete purchaseUpdateOrdersListData[k]
  );

  console.log(
    purchaseUpdateOrdersList,
    purchaseOrdersList,
    "purchaseUpdateOrdersList"
  );

  //Create purchase orders
  const createPurchaseOrdersApi = () => {
    if (!isEmpty(poNo) && !isEmpty(poDate) && !isEmpty(validDate)) {
      dispatch(createPurchaseList(purchaseOrdersListData));
      setTimeout(() => {
        dispatch(loadPurchaseOrders(purchaseList));
        toast.success("Purchase orders created successfully ");
        history.push("/purchase-orders");
      }, 1500);
    } else {
      toast.error("Purchase orders details cannot be empty");
    }
  };

  //update purchase orders
  const updatePurchaseOrdersApi = () => {
    if (!isEmpty(poNo) && !isEmpty(poDate) && !isEmpty(validDate)) {
      dispatch(updatePurchaseList(purchaseUpdateOrdersListData));
      setTimeout(() => {
        dispatch(loadPurchaseOrders(purchaseList));
        toast.success("Purchase orders updated successfully");
        history.push("/purchase-orders");
      }, 1500);
    } else {
      toast.error("Purchase orders details cannot be empty");
    }
  };

  useBeforeUnload({
    when: !isEmpty(totalSectionData),
    message: "Are you sure you want to leave?",
  });

  //updated data
  useEffect(() => {
    if (updatedData) {
      setPartyModalData({
        ...partyModalData,
        _id: updatedData ? updatedData._id : "",
        vendorName: updatedData ? updatedData.vendorName : "",
        totalAddress: updatedData
          ? updatedData.vendorAddress + ", " + updatedData.vendorCity
          : "",
        billingAddress: updatedData ? updatedData.vendorAddress : "",
        cityName: updatedData ? updatedData.vendorCity : "",
        state: "66c8829ff4eec74eb828961f",
        vendorId: updatedData ? updatedData.vendorId : "",
      });
      setStateData("Tamil Nadu");
      const updatedPoNo = updatedData ? updatedData.poNo : "";
      const updatedPoDate = updatedData
        ? moment(updatedData.poDate).format("YYYY-MM-DD")
        : "";
      const updatedValidDate =
        updatedData && updatedData.povalidDate
          ? moment(updatedData.povalidDate).format("YYYY-MM-DD")
          : "";
      setPoNo(updatedPoNo);
      setPoDate(updatedPoDate);
      setValidDate(updatedValidDate);

      dispatch(loadPurchaseRecordsMetaData());
      const updatedItemValues =
        updatedData && updatedData.items.length > 0
          ? updatedData.items.map((data) => {
              const quantityCount =
                data.subtotal && data.priceofitem
                  ? parseInt(data.subtotal - data.priceofitem)
                  : 0;

              return {
                discountPrice: data.discountValue ? data.discountValue : 0,
                discountPercentage: data.discountpercentage
                  ? data.discountpercentage
                  : 0,
                _id: data.itemId,
                hsnCode: data.hsnCode ? data.hsnCode : "",
                quantityCount: data.qty
                  ? data.qty
                  : quantityCount <= 18
                  ? 1
                  : 0,
                noofStock: data.qty ? data.qty : quantityCount <= 18 ? 1 : 0,
                itemName: data.itemName,
                salesPrice: data.priceofitem,
                subtotal: data.subtotal,
                taxValue: data.taxValue,
                taxPercentageId: "18%",
                taxPercentageName: data.taxpercentageId,
                taxPercentageValue: 18,
                totalAmount: data.totalamount,
                itemUpdateId: data._id,
              };
            })
          : [];
      setItemSelectedRows(updatedItemValues);
      if (updatedData.notes) {
        setNotesOpen(true);
      }
      setNotes(updatedData.notes);
      if (updatedData.termsandconditions) {
        setTermsOpen(true);
      }
      if (updatedData.autoamountroundoff) {
        setAdditionalChargesOpen(true);
      }

      setTermsConditions(updatedData.termsandconditions);
      const chargesValue =
        updatedData && updatedData.charge.length > 0
          ? updatedData.charge[0]
          : "";
      const chargeNameValue =
        updatedData && chargesValue ? chargesValue.chargeName : "";
      const chargeName =
        chargeNameValue && !isEmpty(chargeNameValue)
          ? chargeNameValue
          : "No Tax Applicable";
      //total section data
      setTotalSectionData({
        ...totalSectionData,
        totalAmount: updatedData.NetAmount,
        autoRoundOffValue: updatedData.autoamountroundoff,
        chargesData: "",
        // netAmount: updatedData.NetAmount,
        additionalCharges:
          chargesValue && !isUndefined(chargesValue.chargeAmount)
            ? chargesValue.chargeAmount
            : 0,
        chargeId:
          chargesValue && !isUndefined(chargesValue._id)
            ? chargesValue._id
            : "",
      });
      setAutoRoundOffMethod(updatedData.type);
      setAdditionalOptions(chargeName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>
            {" "}
            {!isEmpty(updatedData) ? "Update Purchase" : "Add Purchase"} | Mbook
          </title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-1 font-semibold"
              >
                {!isEmpty(updatedData)
                  ? "Update Purchase Order"
                  : "Add Purchase Order"}
              </h1>
            </div>
            <div className="flex">
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                >
                  Settings <SettingOutlined />
                </div>
              </Tooltip>
              <div className="border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer">
                Save & New
              </div>
              <div
                onClick={() => {
                  if (!isEmpty(updatedData)) {
                    updatePurchaseOrdersApi();
                  } else {
                    createPurchaseOrdersApi();
                  }
                }}
                className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
              >
                {!isEmpty(updatedData) ? "Update" : "Save"}
              </div>
            </div>
          </div>
        </Col>
        <div className="add-purchase-main pr-4 pl-5 pt-3 mt-4">
          <Col span={24} className="add-purchase-card">
            {/* File form section */}
            <Row className="border border-t-0 border-r-0 border-b-1">
              <Col
                span={15}
                className="flex border border-r-1 border-l-0 border-b-0 border-t-0"
              >
                <Row className="w-[100%]">
                  <Col
                    span={
                      !isEmpty(partyModalData._id) &&
                      !isEmpty(partyModalData.vendorName)
                        ? 12
                        : 24
                    }
                  >
                    <div className="w-[100%] flex justify-between border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                      <h1 className="ml-3 purchase-label text-[14px] font-medium">
                        Bill From
                      </h1>
                      {!isEmpty(partyModalData._id) &&
                      !isEmpty(partyModalData.vendorName) ? (
                        <div className="">
                          <div
                            onClick={() => {
                              setPartyModal(true);
                              setPartyMode("Add");
                              dispatch(loadVendor(purchaseList));
                            }}
                            className="text-center text-[11px] cursor-pointer border border-1 rounded-md border-gray-400 pl-2 pr-2"
                          >
                            Change Vendor
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <Row className="p-6">
                      {partyModal === true ? (
                        <Col
                          span={
                            !isEmpty(partyModalData._id) &&
                            !isEmpty(partyModalData.vendorName)
                              ? 20
                              : 16
                          }
                          className="purchase-party-card"
                        >
                          <Row className="flex flex-col mb-1">
                            <Col
                              span={24}
                              className="flex justify-end pt-2 pr-2"
                            >
                              <CloseCircleOutlined
                                onClick={() => setPartyModal(false)}
                              />
                            </Col>
                            <Col span={24} className="pr-3 pl-3 pt-2 pb-2">
                              <AutoComplete className="mt-2 border border-none rounded-sm mb-2 w-[100%] mr-2">
                                <Input.Search
                                  size="large"
                                  placeholder="Search party by name or phone number"
                                  value={search}
                                  onChange={(e) => handleSearch(e)}
                                  // enterButton
                                />
                              </AutoComplete>
                            </Col>
                            <Col span={24} className="">
                              <div>
                                <div className="purchase-label flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 text-[14px]">
                                    Party Name
                                  </h1>
                                  <p className="mr-2 text-[14px]">Balance</p>
                                </div>
                                <div className="purchase-label bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 font-semibold text-[14px]">
                                    Cash Sale
                                  </h1>
                                  <p className="mr-2 font-semibold text-[14px]">
                                    0.0
                                  </p>
                                </div>
                                <div
                                  className={
                                    vendorRows.length > 3
                                      ? "purchase-party-scroll"
                                      : ""
                                  }
                                >
                                  {vendorRows.length > 0
                                    ? vendorRows.map((data, index) => {
                                        const billingAddressData =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].address1
                                            : "";
                                        const billingAddressState =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].state
                                            : "";
                                        const billingAddressStateName =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].stateName
                                            : "";
                                        const billingAddressPincode =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].pincode
                                            : "";
                                        const billingAddressCity =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].city
                                            : "";

                                        const totalBillingAddress =
                                          !isEmpty(billingAddressData) &&
                                          billingAddressCity !== undefined &&
                                          billingAddressStateName !==
                                            undefined &&
                                          billingAddressPincode
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              ", " +
                                              billingAddressStateName +
                                              ", " +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              billingAddressCity &&
                                              billingAddressStateName ===
                                                undefined &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              " ," +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressPincode
                                            : "";

                                        //shipping address
                                        const shippingAddressData =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].address1
                                            : "";
                                        const shippingAddressState =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].state
                                            : "";
                                        const shippingAddressStateName =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].stateName
                                            : "";
                                        // const shippingAddressCityName =
                                        //   data &&
                                        //   data.shippingAddress &&
                                        //   data.shippingAddress.length > 0
                                        //     ? data.shippingAddress[0].city
                                        //     : "";
                                        const shippingAddressPincode =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].pincode
                                            : "";
                                        const shippingAddressCity =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].city
                                            : "";
                                        console.log(
                                          shippingAddressCity,
                                          "shippingAddressCity"
                                        );
                                        console.log(
                                          data.shippingAddress,
                                          "data.shippingAddress"
                                        );
                                        const totalAddress =
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressCity +
                                              ", " +
                                              shippingAddressStateName +
                                              ", " +
                                              shippingAddressPincode
                                            : !isEmpty(shippingAddressData) &&
                                              shippingAddressCity &&
                                              !isEmpty(shippingAddressPincode)
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressCity +
                                              " ," +
                                              shippingAddressPincode
                                            : !isEmpty(shippingAddressData) &&
                                              !isEmpty(shippingAddressPincode)
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressPincode
                                            : "";
                                        console.log(
                                          totalAddress,
                                          "totalAddress"
                                        );
                                        return (
                                          <div
                                            key={index}
                                            className="cursor-pointer"
                                            onClick={() => {
                                              // setCreatePartyModal(false);
                                              setPartyModal(false);
                                              setPartyModalData({
                                                vendorName: data.vendorName
                                                  ? data.vendorName
                                                  : "",
                                                mobile: data.mobile
                                                  ? data.mobile
                                                  : "",
                                                billingAddress:
                                                  shippingAddressData,
                                                cityName: shippingAddressCity
                                                  ? shippingAddressCity
                                                  : "",
                                                gstIn: data.gstIn
                                                  ? data.gstIn
                                                  : "",
                                                totalAddress: totalAddress,
                                                state: shippingAddressState,
                                                _id: data._id,
                                                billingCityName:
                                                  billingAddressCity,
                                                billingAddressValue:
                                                  billingAddressData,
                                                totalBillingAddress:
                                                  totalBillingAddress,
                                                billingState:
                                                  billingAddressState,
                                              });
                                              setPincode(
                                                shippingAddressPincode
                                              );
                                              setStateData(
                                                shippingAddressStateName
                                              );
                                              setBillingPincode(
                                                billingAddressPincode
                                              );
                                              setBillingStateData(
                                                billingAddressStateName
                                              );
                                              // setPartyMode("Update");
                                            }}
                                          >
                                            {tableLoading ? (
                                              <Skeleton.Input
                                                style={{
                                                  margin: "6px 3px",
                                                  minWidth: "120%",
                                                  height: "60px",
                                                }}
                                                className="border border-b-1.5 border-x-0 border-t-0"
                                                // className="tabs-skeleton"
                                                active={true}
                                                size={"large"}
                                              ></Skeleton.Input>
                                            ) : (
                                              <div className="purchase-label hover:bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                                <h1 className="ml-2 text-[14px]">
                                                  {data.vendorName}
                                                </h1>
                                                <p className="mr-2 flex text-[14px]">
                                                  <p className="mr-2">
                                                    {data.openingbalanceType ===
                                                    "To Collect" ? (
                                                      <ArrowDownOutlined className="text-[green]" />
                                                    ) : (
                                                      ""
                                                    )}
                                                  </p>{" "}
                                                  {data.currentBalance}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    : ""}
                                </div>
                              </div>
                            </Col>
                            <Col span={24} className="p-3">
                              <div
                                onClick={() => {
                                  setCreatePartyModal(true);
                                  dispatch(loadPurchaseRecordsMetaData());
                                }}
                                className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-2 pb-2 pl-10 pr-10"
                              >
                                <PlusOutlined /> Create Vendor
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      ) : !isEmpty(partyModalData._id) &&
                        !isEmpty(partyModalData.vendorName) ? (
                        <Row className="ml-[-6px] w-[100%] mb-6">
                          <Col span={24}>
                            <div>
                              <h1 className="purchase-label text-[14px] font-semibold">
                                {!isEmpty(partyModalData.vendorName) &&
                                  partyModalData.vendorName}
                              </h1>
                              {/* <div className="flex">
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Address:
                                </p>
                                <p>
                                  {partyModalData &&
                                  partyModalData.totalBillingAddress &&
                                  !isEmpty(partyModalData.totalBillingAddress)
                                    ? partyModalData.totalBillingAddress
                                    : ""}
                                </p>
                              </div> */}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <div className="w-[50%]">
                          <div
                            onClick={() => {
                              setPartyModal(true);
                              setPartyMode("Add");
                              dispatch(loadVendor(purchaseList));
                            }}
                            className="text-center text-[#488dff] cursor-pointer border border-dashed border-2 border-blue-400 p-12"
                          >
                            <PlusOutlined /> Add Vendor
                          </div>
                        </div>
                      )}
                    </Row>
                  </Col>
                  <Col
                    span={12}
                    className="border border-l-1 border-t-0 border-r-0 border-b-0"
                  >
                    {!isEmpty(partyModalData._id) &&
                    !isEmpty(partyModalData.vendorName) ? (
                      <>
                        <div className="flex justify-between border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                          <h1 className="ml-3 purchase-label text-[14px] font-medium">
                            Ship From
                          </h1>

                          <div className="">
                            <div
                              onClick={() => {
                                setCreateShippingModal(true);
                                // dispatch(loadVendor(purchaseList));
                                dispatch(
                                  loadPartyVendorAddress({
                                    partyorvendorId: partyModalData._id,
                                    organizationId: organizationId,
                                  })
                                );
                                dispatch(loadPurchaseRecordsMetaData());
                              }}
                              className="text-center text-[11px] cursor-pointer border border-1 rounded-md border-gray-400 pl-2 pr-2"
                            >
                              Change Shipping Address
                            </div>
                          </div>
                        </div>
                        <Row className="p-5 w-[100%] mb-6">
                          <Col span={24}>
                            <div>
                              <h1 className="purchase-label text-[14px] font-semibold">
                                {!isEmpty(partyModalData.vendorName) &&
                                  partyModalData.vendorName}
                              </h1>
                              <div className="flex">
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Address:
                                </p>
                                <p>
                                  {partyModalData &&
                                  !isEmpty(partyModalData.totalAddress)
                                    ? partyModalData.totalAddress
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={9}>
                <Row className="pl-3 pt-3">
                  <Col span={10} className="pr-3">
                    <Typography className="input-label mb-1 text-[10px]">
                      PO No: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <Input
                      name="poNo"
                      value={poNo}
                      className="rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      onChange={(e) => setPoNo(e.target.value)}
                      placeholder="Enter PO No"
                    />
                    {/* <p className="text-start text-[red] mt-2 mb-3">
                      {simpleValidator.current.message(
                        "poNo",
                        poNo,
                        "required"
                      )}
                    </p> */}
                  </Col>
                  <Col span={8} className="pr-3">
                    <Typography className="input-label mb-1 text-[10px]">
                      PO Date: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <DatePicker
                      // name="poDate"
                      // format="YYYY-MM-DD"
                      // defaultValue={moment()}
                      selected={poDate}
                      className="rounded-md pl-2 border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      onChange={handlePoDateChange}
                      icon={<BiCalendar size={18} className="text-[#9e9e9e]" />}
                      placeholderText="Select Date"
                    />
                    {/* <p className="text-start text-[red] mt-2 mb-3">
                      {simpleValidator.current.message(
                        "poDate",
                        poDate,
                        "required"
                      )}
                    </p> */}
                  </Col>
                  <Col span={8} className="pr-3 mt-2">
                    <Typography className="input-label mb-1 text-[10px]">
                      Valid Till <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <DatePicker
                      // name="validDate"
                      placeholderText="Select Date"
                      // defaultValue={moment().add(1, "month")}
                      selected={validDate}
                      className="rounded-md pl-2 border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      onChange={handleValidDateChange}
                      icon={<BiCalendar size={18} className="text-[#9e9e9e]" />}
                    />
                    {/* {simpleValidator.current.message(
                      "validDate",
                      validDate,
                      "required"
                    )} */}
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Item table section */}
            <Row className="border border-x-0 border-y-0 p-5">
              <Col
                span={24}
                className="p-2 add-create-item-table  border border-x-0 border-y-0"
              >
                <table className="table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-head uppercase text-[12px] font-medium">
                        No
                      </th>
                      <th className="w-[28%] table-head uppercase text-[12px] font-medium">
                        Items/ Services
                      </th>
                      <th className="w-[8%] table-head uppercase text-[12px] font-medium">
                        HSN/ SAC
                      </th>
                      {/* {purchaseData.travel === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Travel
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.batch === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Batch no.
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.expiryDate === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Exp. Date
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.mfgDate === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Mfg Date
                        </th>
                      ) : (
                        ""
                      )} */}
                      {purchaseData.quantity === true ? (
                        <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                          Qty
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.price === true ? (
                        <th className="w-[11%] table-head uppercase text-[12px] font-medium">
                          Price/Item (₹)
                        </th>
                      ) : (
                        ""
                      )}

                      <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                        Discount
                      </th>
                      <th className="w-[11%] table-head uppercase text-[12px] font-medium">
                        Tax
                      </th>
                      <th className="w-[11%] table-head uppercase text-[12px] font-medium">
                        Amount (₹)
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          <PlusCircleFilled className="text-[30px] text-[#8b8787]" />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      itemSelectedRows.map((data, index) => {
                        //console.log(data, "data rows");
                        const taxFinalValue = data.quantityCount
                          ? parseInt(data.taxValue)
                          : data.taxValue;
                        return (
                          <tr
                            key={index}
                            className="table-purchase-orders-row p-2"
                          >
                            <td className="table-data font-medium text-center">
                              {index + 1}
                            </td>
                            <td className="table-data font-semibold font-medium text-start">
                              {data.itemName}

                              <Input
                                name="itemDescription"
                                value={data.itemDescription}
                                className="p-2 mt-[3px] h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="Enter Description (optional)"
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "itemDescription",
                                    index
                                  )
                                }
                              />
                            </td>
                            <td className="table-data font-medium text-start">
                              {data.hsnCode}
                            </td>
                            {/* {purchaseData.travel === true ? (
                              <td className="table-data font-medium text-center">
                                {data.travel ? data.travel : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.batch === true ? (
                              <td className="table-data font-medium text-center">
                                {data.batch ? data.batch : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.expiryDate === true ? (
                              <td className="table-data font-medium text-center">
                                {data.expiryDate ? data.expiryDate : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.mfgDate === true ? (
                              <td className="table-data font-medium text-center">
                                {data.mfgDate ? data.mfgDate : "--"}
                              </td>
                            ) : (
                              ""
                            )}*/}
                            {purchaseData.quantity === true ? (
                              <td className="table-data font-medium text-start">
                                <Input
                                  name="quantityCount"
                                  value={data.quantityCount}
                                  className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                  placeholder="Enter Qty (optional)"
                                  onChange={(e) =>
                                    itemSelectedChange(
                                      e,
                                      "quantityCount",
                                      index
                                    )
                                  }
                                  style={{
                                    textAlign: "end",
                                  }}
                                  suffix={"PCS"}
                                />{" "}
                                {/* PCS */}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.price === true ? (
                              <td className="table-data font-medium text-center">
                                <Input
                                  name="salesPrice"
                                  value={data.salesPrice}
                                  prefix={"₹"}
                                  className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                  placeholder="Enter price"
                                  onChange={(e) =>
                                    itemSelectedChange(e, "salesPrice", index)
                                  }
                                  style={{
                                    textAlign: "right",
                                  }}
                                />
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="table-data font-medium">
                              <Input
                                name="discountPercentage"
                                suffix={"%"}
                                value={data.discountPercentage}
                                className="p-2 mb-1 h-[30px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="%"
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "discountPercentage",
                                    index
                                  )
                                }
                              />

                              <Input
                                name="discountPrice"
                                value={data.discountPrice}
                                className="p-2 h-[30px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="price"
                                prefix={"₹"}
                                onChange={(e) =>
                                  itemSelectedChange(e, "discountPrice", index)
                                }
                              />
                            </td>
                            <td className="table-data font-medium">
                              <Select
                                name="taxPercentageId"
                                value={data.taxPercentageId}
                                options={
                                  recordsMetaData
                                    ? recordsMetaData.gstPercentageOptions
                                    : []
                                }
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "taxPercentageId",
                                    index
                                  )
                                }
                                className="h-[40px] w-[100%] border-none hover:bg-[#e9ecf1]"
                                placeholder="% 0"
                              />
                              <p className="text-center mt-1">
                                {data.taxValue ? `(₹ ${taxFinalValue})` : ""}
                              </p>
                            </td>
                            <td className="table-data font-medium text-center">
                              <Input
                                name="totalAmount"
                                value={data.totalAmount}
                                className="p-2 h-[35px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="Enter price"
                                prefix={"₹"}
                                onChange={(e) =>
                                  itemSelectedChange(e, "totalAmount", index)
                                }
                              />
                            </td>
                            <td className="table-data font-medium text-center">
                              <DeleteOutlined
                                onClick={() => removeItemsData(index)}
                                type="primary"
                                className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                                size={"large"}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={11} className="text-center">
                          {/* No Data Found */}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
              <Col span={24} className="mt-2">
                <Row>
                  <Col span={18}>
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(false);
                        dispatch(loadCategory(purchaseList));
                        dispatch(loadItems(purchaseList));
                      }}
                      className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-5 pb-5 pl-10 pr-10"
                    >
                      <PlusOutlined /> Add Item
                    </div>
                  </Col>
                  <Col span={6} className="pl-4">
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(true);
                      }}
                      className="cursor-pointer flex border border-1 pt-3 pb-3 pl-5 pr-5"
                    >
                      <PiBarcodeBold size={40} className="mr-2" />
                      <h1 className="purchase-label text-[18px] mt-2 font-medium">
                        Scan Barcode
                      </h1>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Total section */}
            <Row className="bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3">
              <Col span={14} className="flex justify-end">
                <div className="flex">
                  <h1 className="text-[14px] pr-2 text-end purchase-label font-semibold">
                    SUB-Total
                  </h1>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-purchase-orders-divider"
                  />
                </div>
              </Col>
              <Col span={3}>
                <div className="flex">
                  <div className="flex">
                    <p className="text-[14px] pr-2 font-semibold">₹</p>
                    <h1 className="text-[14px] pr-2 text-end purchase-label font-semibold">
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? totals.discountPrice
                        : // : itemSelectedRows.length > 1
                          // ? discountPriceTotal
                          0}
                      {/* ₹ {0} */}
                    </h1>
                  </div>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-purchase-orders-divider"
                  />
                </div>
              </Col>
              <Col span={3}>
                <div className="flex">
                  <div className="flex">
                    <p className="text-[14px] pr-2 font-semibold">₹</p>
                    <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? totals.taxValue
                        : // : itemSelectedRows.length > 1
                          // ? taxValueTotal
                          0}
                      {/* ₹ {taxValueTotal} */}
                    </h1>
                  </div>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-purchase-orders-divider"
                  />
                </div>
              </Col>
              <Col span={4}>
                <div className="flex">
                  <p className="text-[14px] pr-2 font-semibold">₹</p>
                  <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                    {itemSelectedRows && itemSelectedRows.length > 0
                      ? totals.totalAmount
                      : // : itemSelectedRows.length > 1
                        // ? selectedItemsTotal
                        0}
                    {/* ₹ {selectedItemsTotal} */}
                  </h1>
                </div>
              </Col>
            </Row>

            {/* Add notes, total section */}
            <Row className="border border-x-0 border-t-0 border-b-1">
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  {notesOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Notes
                        <CloseCircleOutlined
                          onClick={() => setNotesOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Enter your notes"
                        className="p-2 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setNotesOpen(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Notes
                    </div>
                  )}
                  {termsOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Terms and Conditions{" "}
                        <CloseCircleOutlined
                          onClick={() => setTermsOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="termsConditions"
                        value={termsConditions}
                        onChange={(e) => setTermsConditions(e.target.value)}
                        placeholder="Enter your terms & conditions"
                        className="p-3 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setTermsOpen(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Terms and Conditions
                    </div>
                  )}
                </div>
              </Col>
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                {/* Total , after gst section */}
                {discount === "Display Before Tax" ? (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2 text-[16px] pt-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div onClick={() => setDiscountOpen(true)}>
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice
                              : // : itemSelectedRows.length > 1
                                // ? discountPriceTotal
                                0}
                          </h1>
                        </div>
                      </div>
                    )}

                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "160px",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div>
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                    {/* <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-4 flex justify-between mb-3 cursor-pointer"
                    >
                      <h1 className="text-[14px] purchase-label">
                        Taxable Amount
                      </h1>
                      <p className="text-[15px] flex font-semibold">
                        ₹{" "}
                        <p className="purchase-label text-[14px] ml-1 mt-[1.5px]">
                          {" "}
                          {itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          itemSelectedRows.length == 1
                            ? itemSelectedRows[0].salesPrice
                            : itemSelectedRows.length > 1
                            ? totals.salesPrice
                            : 0}{" "}
                        </p>
                      </p>
                    </div> */}
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      <>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-3 cursor-pointer"
                        >
                          {itemSelectedRows && itemSelectedRows.length > 0
                            ? itemSelectedRows.map((data) => {
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @
                                      {data.taxPercentageValue
                                        ? parseInt(data.taxPercentageValue) / 2
                                        : 0}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.taxValue
                                          ? parseInt(data.taxValue) / 2
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-3 cursor-pointer"
                        >
                          {itemSelectedRows && itemSelectedRows.length > 0
                            ? itemSelectedRows.map((data) => {
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @
                                      {data.taxPercentageValue
                                        ? parseInt(data.taxPercentageValue) / 2
                                        : 0}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.taxValue
                                          ? parseInt(data.taxValue) / 2
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "160px",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div>
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                    {/* <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-4 flex justify-between mb-3 cursor-pointer"
                    >
                      <h1 className="text-[14px] purchase-label">
                        Taxable Amount
                      </h1>
                      <p className="text-[15px] flex font-semibold">
                        ₹{" "}
                        <p className="purchase-label text-[14px] ml-1 mt-[1.5px]">
                          {" "}
                          {itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          itemSelectedRows.length == 1
                            ? itemSelectedRows[0].salesPrice
                            : itemSelectedRows.length > 1
                            ? totals.salesPrice
                            : 0}{" "}
                        </p>
                      </p>
                    </div> */}
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      <>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-3 cursor-pointer"
                        >
                          {itemSelectedRows && itemSelectedRows.length > 0
                            ? itemSelectedRows.map((data) => {
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @
                                      {data.taxPercentageValue
                                        ? parseInt(data.taxPercentageValue) / 2
                                        : 0}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.taxValue
                                          ? parseInt(data.taxValue) / 2
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-3 cursor-pointer"
                        >
                          {itemSelectedRows && itemSelectedRows.length > 0
                            ? itemSelectedRows.map((data) => {
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      CGST @
                                      {data.taxPercentageValue
                                        ? parseInt(data.taxPercentageValue) / 2
                                        : 0}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.taxValue
                                          ? parseInt(data.taxValue) / 2
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div onClick={() => setDiscountOpen(true)}>
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice
                              : // : itemSelectedRows.length > 1
                                // ? discountPriceTotal
                                0}
                          </h1>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="w-[100%] mt-2 purchase-label flex justify-between mb-3 cursor-pointer"
                  >
                    <Checkbox
                      type="checkbox"
                      name="autoRoundfOff"
                      height={14}
                      width={14}
                      // defaultChecked
                      value={autoRoundOff}
                      onChange={(e) => setAutoRoundOff(e.target.checked)}
                      className="w-[50%] text-[#084d7b]"
                    >
                      <p className={autoRoundOff === false ? "mt-2" : ""}>
                        {" "}
                        Auto Round Off{" "}
                      </p>
                    </Checkbox>
                    {autoRoundOff === false ? (
                      <Input
                        name="autoRoundOffValue"
                        value={totalSectionData.autoRoundOffValue}
                        onChange={(e) => handlePurchaseChange(e)}
                        addonBefore={
                          <Select
                            value={autoRoundOffMethod}
                            onChange={(e) => setAutoRoundOffMethod(e)}
                            style={{
                              width: 110,
                              height: 25,
                            }}
                            options={[
                              {
                                value: "add",
                                label: "+ Add",
                              },
                              {
                                value: "reduce",
                                label: "- Reduce",
                              },
                            ]}
                          />
                        }
                        type="text"
                        prefix={"₹ "}
                        placeholder="0"
                        className="w-[50%] mb-3 h-[25px]"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="mt-5 font-semibold flex justify-between mb-3 cursor-pointer"
                  >
                    <h1 className="w-[50%] purchase-label text-[14px] mt-1">
                      Total Amount
                    </h1>
                    <h1 className="text-[16px]">
                      ₹.{" "}
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? netAmount
                        : 0}
                    </h1>
                    {/* <Input
                      name="totalAmount"
                      value={totalSectionData.totalAmount}
                      onChange={(e) => handlePurchaseChange(e)}
                      type="text"
                      prefix={"₹ "}
                      placeholder="Enter Payment Amount"
                      className="w-[50%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] h-[25px]"
                    /> */}
                  </div>
                </div>
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-3 p-3 text-[14px] mb-2 purchase-label mb-3 cursor-pointer"
                >
                  <div className="flex justify-end">
                    <h1>Authorized signatory for</h1>
                    <p className="font-semibold ml-2">{organizationName}</p>
                  </div>
                  <div className="flex justify-end mt-2 mb-2 ml-10">
                    <Upload
                      action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleImageChange}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{
                          display: "none",
                        }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {/* Custom fields modal */}
        <Modal
          open={columnSettings}
          title="Show/Hide Columns in Invoice"
          onOk={() => setColumnSettings(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          className="mt-[-70px]"
          onCancel={() => setColumnSettings(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            // className="w-[110%] ml-[-24px]"
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-3px",
            }}
          />
          <Col className="mb-3">
            <div className="purchase-label flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Column Name</h1>
              <p>Show</p>
            </div>

            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Price/ Item(₹)</h1>
              <Switch
                value={purchaseData.price}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    price: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Quantity</h1>
              <Switch
                value={purchaseData.quantity}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    quantity: checked,
                  })
                }
              />
            </div>
            <div className="purchase-label mt-[-5px] flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Custom Column Name</h1>
              <p>Show</p>
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Travel</h1>
              <Switch
                value={purchaseData.travel}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    travel: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Batch No</h1>
              <Switch
                value={""}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    batch: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Expiry Date</h1>
              <Switch
                value={purchaseData.expiryDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    expiryDate: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>mfgDate</h1>
              <Switch
                value={purchaseData.mfgDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    mfgDate: checked,
                  })
                }
              />
            </div>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 flex bg-[#ffb8001a] purchase-label text-[10px] terms-conditions-card mb-3 mt-1 pr-3"
          >
            <h1 className="flex font-bold ml-10">
              <p className="flex font-medium ml-2">
                To add Custom Item Columns - Go to Item settings from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Items page (click here)
                </p>
              </p>
            </h1>
          </Col>
        </Modal>
        {/* settings Field Modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Purchase Invoice Settings"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Purchase Invoice Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="purchase-label mb-1">
                    Prefix
                  </Typography>
                  <Input
                    name="prefix"
                    value={purchaseSettings.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix purchase-label"
                    className="p-2"
                  />
                </Col>
                <Col span={8}>
                  <Typography className="mb-1 purchase-label">
                    Sequence Number
                  </Typography>
                  <Input
                    name="seqNo"
                    value={purchaseSettings.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2 purchase-label"
                  />
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="purchase-label mb-1">
                    Purchase Invoice Number:{" "}
                    {!isEmpty(purchaseSettings.seqNo)
                      ? purchaseSettings.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createPartyModal}
          title={
            partyMode === "Update" ? "Update New Vendor" : "Create New Vendor"
          }
          onOk={() => {
            if (partyMode === "Update") {
              updateVendorApi();
            } else {
              createVendorApi();
            }
          }}
          closeIcon
          maskClosable={false}
          okText={partyMode === "Update" ? "Update" : "Save"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setCreatePartyModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="">
                <Typography className="text-[gray] input-required-label uppercase flex">
                  Vendor Name <p className="text-[red]">*</p>
                </Typography>
                <Input
                  name="vendorName"
                  value={partyModalData.vendorName}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter name"
                  className="p-2"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {simpleValidator.current.message(
                    "vendorName",
                    partyModalData.vendorName,
                    "required"
                  )}
                </p>
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="text-[gray] input-label mb-1 uppercase">
                  Mobile Number
                </Typography>
                <Input
                  name="mobile"
                  value={partyModalData.mobile}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter Mobile No"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mt-3">
                <div className="">
                  {addAddressShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add Address</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddAddressShow(false)}
                        >
                          Remove
                        </p>
                      </Col>
                      <Col span={24} className="mt-3">
                        <Typography className="text-[gray] flex input-required-label uppercase">
                          Billing Address
                          <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Input.TextArea
                          name="billingAddress"
                          value={partyModalData.billingAddress}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter Billing Address"
                          className="p-3 h-[35px]"
                        />
                        <p className="text-start text-[red] mt-2 mb-3">
                          {simpleValidator.current.message(
                            "billingAddress",
                            partyModalData.billingAddress,
                            "required"
                          )}
                        </p>
                      </Col>
                      <Col span={12} className="mt-2 pr-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          State
                        </Typography>
                        <Select
                          style={{
                            width: 250,
                            height: 40,
                          }}
                          value={stateData}
                          onChange={(e) => setStateData(e)}
                          placeholder="Select State"
                          options={
                            recordsMetaData ? recordsMetaData.stateOptions : []
                          }
                        />
                      </Col>
                      <Col span={12} className="mt-2 pl-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          Pincode
                        </Typography>
                        <Input
                          name="pincode"
                          value={pincode}
                          onChange={(e) => {
                            const name = "pincode";
                            const validationRules = {
                              pincode: /^[0-9]*$/,
                            };
                            if (validationRules[name]) {
                              if (
                                validationRules[name].test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                setPincode(e.target.value);
                              }
                            }

                            axios
                              .get(
                                `https://api.postalpincode.in/pincode/${e.target.value}`
                              )
                              .then((res) => {
                                //console.log(res, "res");
                                if (e.target.value.length === 6) {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName:
                                      res &&
                                      res.data &&
                                      res.data.length > 0 &&
                                      res.data[0].PostOffice !== null
                                        ? res.data[0].PostOffice[0].District
                                        : "",
                                  });
                                } else {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName: "",
                                  });
                                }
                              });
                          }}
                          maxLength={6}
                          placeholder="Enter pincode"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          City
                        </Typography>
                        <Input
                          name="cityName"
                          value={partyModalData.cityName}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter City"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-3 mb-1">
                        <div className="flex">
                          <Checkbox
                            type="checkbox"
                            name="sameAs"
                            height={14}
                            width={14}
                            defaultChecked
                            value={sameAs}
                            onChange={(e) => setSameAs(e.target.checked)}
                            className="text-[#084d7b]"
                          >
                            Same as Billing Address
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddAddressShow(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Address (Optional)
                    </div>
                  )}
                  {addGstShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add GST (Optional)</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddGstShow(false)}
                        >
                          Remove
                        </p>
                      </Col>

                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          GSTIN
                        </Typography>
                        <Input
                          name="gstIn"
                          value={partyModalData.gstIn}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter gstIn"
                          className="p-2 text-semibold"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddGstShow(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add GSTIN (Optional)
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 bg-[#ffb8001a] purchase-label text-[12px] terms-conditions-card pr-3"
          >
            <h1 className="flex justify-center font-bold ml-15">
              <p className="flex font-medium ml-2">
                You can add Custom Fields from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Party settings
                </p>
              </p>
            </h1>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createShippingModal}
          title={"Change Shipping Address"}
          onOk={() => {
            setCreateShippingModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setCreateShippingModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mt-[-8px]">
            <Row
              style={{
                fontFamily: "Poppins",
                borderBottomWidth: "0.1px",
                width: "108.5%",
                marginLeft: "-24px",
              }}
              className="text-[12px] font-semobild p-2"
            >
              <Col
                style={{ fontFamily: "Poppins", paddingLeft: "10px" }}
                span={16}
              >
                Address
              </Col>
              <Col style={{ fontFamily: "Poppins" }} span={6}>
                Edit
              </Col>
              <Col style={{ fontFamily: "Poppins" }} span={2}>
                Select
              </Col>
            </Row>
            <>
              {partyAddressData &&
              partyAddressData.length > 0 &&
              partyAddressData[0].address1 ? (
                partyAddressData.map((data, index) => {
                  //console.log(data, "parties address");
                  const address =
                    data.address1 +
                    " " +
                    data.city +
                    ", " +
                    data.stateName +
                    ", " +
                    data.pincode;

                  return (
                    <Row
                      key={index}
                      style={{
                        borderBottomWidth: "0.1px",
                        width: "108.5%",
                        marginLeft: "-24px",
                      }}
                      className="text-[12px] font-semobild p-2"
                    >
                      <Col span={16} className="pl-2">
                        {address ? address : ""}
                      </Col>
                      <Col span={6}>
                        <EditOutlined
                          className="text-[18px]"
                          onClick={() => {
                            setCreateNewShippingModal(true);
                            setNewShippingData({
                              ...newShippingData,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                          }}
                        />
                      </Col>
                      <Col span={2}>
                        <Radio
                          onClick={() => {
                            setPartyCheckedId(data._id);

                            setPartyModalData({
                              ...partyModalData,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                            setNewShippingData({
                              ...newShippingData,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                          }}
                          checked={partyCheckedId == data._id ? true : false}
                          onChange={(e) => {
                            setPartyCheckedId(data._id);
                            if (e.target.checked) {
                              setPartyModalData({
                                ...partyModalData,
                                cityName: data.city,
                                billingAddress: data.address1,
                                state: data.state,
                                totalAddress: address,
                              });
                              setNewShippingData({
                                ...newShippingData,
                                cityName: data.city,
                                billingAddress: data.address1,
                                state: data.state,
                                totalAddress: address,
                              });
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className="text-center">No data found</Row>
              )}
            </>
          </Col>
          <Col
            span={24}
            className="mt-1 mb-2 text-[#4096ff] purchase-label text-[12px] purchase-terms-conditions-card pr-3"
          >
            <h1
              onClick={() => setCreateNewShippingModal(true)}
              className="flex cursor-pointer font-semibold text-[12px]"
            >
              + Add New Shipping Address
            </h1>
          </Col>
          <Divider
            style={{
              borderWidth: "0.2px",
              marginBottom: "2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Billing modal */}
        <Modal
          open={createNewShippingModal}
          title="Shipping Address"
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onClose={() => setCreateNewShippingModal(false)}
          onCancel={() => setCreateNewShippingModal(false)}
          onOk={billingAddressSubmit}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />

          <Row>
            <Col span={24}>
              <Typography className="parties-input-required-label">
                Street Address <p className="text-[red] mx-1">*</p>
              </Typography>
              <Input.TextArea
                name="billingAddress"
                value={newShippingData.billingAddress}
                onChange={(e) => handleShippingModalChange(e)}
                placeholder="Enter Street Address"
                className="pt-2 pb-5 text-semibold"
              />
            </Col>
            <Col span={12} className="mt-1">
              <Typography className="parties-input-label">State</Typography>
              <Select
                style={{
                  width: 250,
                  height: 40,
                }}
                value={shippingState}
                onChange={(e) => setShippingState(e)}
                placeholder="Select State"
                options={recordsMetaData ? recordsMetaData.stateOptions : []}
              />
            </Col>
            <Col span={12} className="mt-2">
              <Typography className="parties-input-label">Pincode</Typography>
              <Input
                name="shippingPincode"
                value={shippingPincode}
                onChange={(e) => {
                  const name = "shippingPincode";
                  const validationRules = {
                    shippingPincode: /^[0-9]*$/,
                  };
                  if (validationRules[name]) {
                    if (
                      validationRules[name].test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      setShippingPincode(e.target.value);
                    }
                  }

                  axios
                    .get(
                      `https://api.postalpincode.in/pincode/${e.target.value}`
                    )
                    .then((res) => {
                      //console.log(res, "res");
                      if (e.target.value.length === 6) {
                        setNewShippingData({
                          ...newShippingData,
                          cityName:
                            res &&
                            res.data &&
                            res.data.length > 0 &&
                            res.data[0].PostOffice !== null
                              ? res.data[0].PostOffice[0].District
                              : "",
                        });
                      } else {
                        setNewShippingData({
                          ...newShippingData,
                          cityName: "",
                        });
                      }
                    });
                }}
                maxLength={6}
                placeholder="Enter pincode"
                className="p-2 text-semibold"
              />
            </Col>
            <Col span={24} className="mt-2">
              <Typography className="parties-input-label">City</Typography>
              <Input
                name="cityName"
                value={newShippingData.cityName}
                onChange={(e) => handleShippingModalChange(e)}
                placeholder="Enter City"
                className="p-2 text-semibold"
              />
            </Col>
          </Row>

          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* item create Modal */}
        <Modal
          open={itemModal}
          title="Add Items"
          onOk={() => {
            setItemModal(false);
            // setPurchaseItemSelect(true);
            // if(itemSelectedRows.length > 0 && itemModal == false) {
            dispatch(loadPurchaseRecordsMetaData());

            // }
          }}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={"80%"}
          className="mt-[-40px]"
          onCancel={() => setItemModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider className="purchase-divider" />
          <Col span={24} className="mt-[-10px]">
            <Row>
              <Col span={8} className="pr-3">
                <AutoComplete
                  style={{
                    width: 170,
                    marginRight: "10px",

                    fontFamily: "Poppins",
                  }}
                >
                  <Input.Search
                    size="large"
                    placeholder="Search Item"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    name="itemSearch"
                    value={itemSearch}
                    onChange={(e) => handleItemSearch(e)}
                  />
                </AutoComplete>
              </Col>
              {scanQrModal === true ? (
                <Col span={6} className="pr-3"></Col>
              ) : (
                <Col span={6} className="pr-3">
                  <Select
                    style={{
                      width: 220,
                      height: 40,
                    }}
                    value={itemCategory}
                    onChange={(e) => {
                      setItemCategory(e);
                      //console.log(e, "category");
                      if (!isEmpty(e)) {
                        const filterRows =
                          itemRows.length > 0 &&
                          itemRows.filter((data) => data.categoryId === e);
                        // console.log(filterRows, "filterRows");
                        const filteredData =
                          filterRows.length > 0 && filterRows;
                        setItemRows(filteredData);
                      }
                    }}
                    suffixIcon={
                      !isEmpty(itemCategory) ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setItemCategory([]);
                            setItemRows(itemsDataTable);
                          }}
                          className="text-[12px]"
                        />
                      ) : (
                        <SearchOutlined className="text-[12px]" />
                      )
                    }
                    onSearch={true}
                    placeholder="Select Categories"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <div className="w-[100%]">
                          <Button
                            type="dashed"
                            className="w-[100%]"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              setItemCategoryModal(true);
                              setCategoryAdditionalFields(false);
                            }}
                          >
                            Add item
                          </Button>
                        </div>
                      </>
                    )}
                    options={categoryOptions}
                  />
                </Col>
              )}

              <Col span={10}>
                {" "}
                <div
                  onClick={() => setCreateItemModal(true)}
                  className="w-[100%] border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                >
                  <PlusOutlined className="mr-1" /> Create New Item
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} className={"add-create-item-main mt-3"}>
                <table className=" table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Name
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Code
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Sales Price
                      </th>
                      {purchaseColumn === true ? (
                        ""
                      ) : (
                        <th className="table-purchase-head mt-1 flex uppercase text-[12px] font-medium">
                          <h1> Purchase Price </h1>{" "}
                          <CloseCircleOutlined
                            onClick={() => setPurchasePriceModal(true)}
                            className="text-[10px] ml-2 text-[black]"
                          />
                        </th>
                      )}

                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Current Stock
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Quantity
                      </th>

                      {/* <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          
                        </div>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {scanQrModal === true ? (
                      <tr key={0} className="text-center">
                        <td
                          colSpan={7}
                          className="cursor-pointer text-center pt-5 pb-5 pl-5 pr-5"
                        >
                          <Image
                            src={qrCodeLogo}
                            preview={false}
                            width={350}
                            height={100}
                          />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {itemRows &&
                        itemRows.length > 0 &&
                        itemRows[0].itemName ? (
                          itemRows.map((data, index) => {
                            return (
                              <tr
                                key={index}
                                className="table-purchase-orders-row"
                              >
                                <td
                                  className="table-purchase-data flex"
                                  // onClick={() => setExpandable(true)}
                                >
                                  <Checkbox
                                    type="checkbox"
                                    name="itemChecked"
                                    height={14}
                                    width={14}
                                    // defaultChecked
                                    checked={itemSelectedRows.some(
                                      (selected) => selected._id == data._id
                                    )}
                                    value={data.itemChecked}
                                    onChange={(e) =>
                                      handleItemChange(
                                        e,
                                        "itemChecked",
                                        index,
                                        data
                                      )
                                    }
                                    className="mr-2 text-[#084d7b]"
                                  />
                                  <p className="mt-1">{data.itemName}</p>
                                </td>
                                <td className="table-purchase-data">
                                  {data.itemCode}
                                </td>
                                <td className="table-purchase-data">
                                  {data.salesPrice}
                                </td>
                                {purchaseColumn === true ? (
                                  ""
                                ) : (
                                  <td className="table-purchase-data">
                                    {data.purchasePrice}
                                  </td>
                                )}

                                <td className="uppercase font-semibold table-purchase-data">
                                  {/* {data.itemName === "Fish" ? (
                                    <div
                                      onClick={() => setBatchingModal(true)}
                                      className="w-[100%] border font-medium text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                    >
                                      <PlusOutlined className="mr-1" /> Create
                                      New Batch
                                    </div>
                                  ) : ( */}
                                  {data.stockQTY}
                                  {/* )} */}
                                </td>
                                <td className="table-purchase-data">
                                  {/* {data.itemName === "Fish" ? (
                                    <div
                                      onClick={() => setBatchingModal(true)}
                                      className="w-[100%] border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                    >
                                      Show Batches{" "}
                                      <DownOutlined className="ml-1" />
                                    </div>
                                  ) : quantityCount === true && */}
                                  {data.stockQTY && data.stockQTY > 1 ? (
                                    <div className="w-[100%] flex justify-between border border-1 text-center rounded-md p-1 cursor-pointer">
                                      <div className="flex">
                                        <p
                                          onClick={() => {
                                            setQuantityCountValue(
                                              quantityCountValue - 1
                                            );

                                            // setQuantityCountId(data._id);
                                            // console.log(
                                            //   data.quantityCount,
                                            //   "quantityCount"
                                            // );
                                            data.quantityCount = parseInt(
                                              data.quantityCount - 1
                                            );
                                          }}
                                          className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                        >
                                          <h1 className="text-[15px] purchase-label font-semibold">
                                            -
                                          </h1>
                                        </p>
                                        <h1 className="text-[14px] font-semibold purchase-label pt-1 pr-3 pl-3">
                                          {data.quantityCount}
                                        </h1>
                                        <p
                                          onClick={() => {
                                            setQuantityCountValue(
                                              quantityCountValue + 1
                                            );
                                            data.quantityCount = parseInt(
                                              data.quantityCount + 1
                                            );
                                          }}
                                          className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                        >
                                          <h1 className="text-[15px] purchase-label font-semibold">
                                            +
                                          </h1>
                                        </p>
                                      </div>
                                      <div className="bg-[#f8f9fc] border border-r-0 border-y-0 border-l-2 p-1 pl-4 pr-4">
                                        <h1 className="pl-2">
                                          {data.noofStock}
                                        </h1>
                                      </div>
                                      {/* <PlusOutlined className="mr-1" /> Add */}
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => {
                                        setQuantityShow(true);
                                      }}
                                      className="w-[100%] border-none bg-[#daedf3] text-[#1677ff]  text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                    >
                                      <PlusOutlined className="mr-1" /> Add
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr key={0} className="table-purchase-orders-row">
                            <td colSpan={7} className="text-center">
                              No Data found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.1px",
              width: "104.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Add Serial Numbers Modal */}
        <Modal
          open={quantityShow}
          title="Add Serial Numbers"
          onOk={() => setQuantityShow(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setQuantityShow(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-2">
                  Item Name
                </Typography>
                <Typography className="purchase-label font-semibold text-[14px] mb-1">
                  Crab
                </Typography>
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Quantity
                </Typography>

                <Input
                  name="serialOpenStock"
                  value={serialOpenStock}
                  onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[6px] pl-[6px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder=""
                />
              </Col>

              <Col span={24} className="pr-4 mb-2">
                <div>
                  <table className="table-purchase-serial table-responsive">
                    <thead>
                      <tr className="table-row">
                        <th className="table-head">IMEI/Serial No</th>
                        <th className="table-head">Date Created</th>
                        <th className="table-head"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {serialData.map((data, index) => {
                        return (
                          <tr key={index} className="">
                            <td className="table-data flex justify-between">
                              <Input
                                name="serialNo"
                                value={data.fieldName}
                                placeholder="Enter Custom Field name"
                                // className="w-[90%]"
                                onChange={(e) =>
                                  handleSerialDataChange(e, "serialNo", index)
                                }
                              />
                            </td>
                            <td className="table-data">
                              {moment().format("Do MMM YYYY")}{" "}
                            </td>
                            <td className="table-data">
                              {" "}
                              <DeleteOutlined
                                onClick={() => removeSerialData(index)}
                                type="primary"
                                className="ml-3 p-2 cursor-pointer"
                                size={"large"}
                              />{" "}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="table-data">
                          <div
                            onClick={() => addSerialData()}
                            className="cursor-pointer text-[#1677ff]"
                          >
                            <PlusOutlined className="mr-2" />
                            Add New Serial No
                          </div>
                        </td>
                        <td className="table-data" colSpan={2}>
                          <div className="flex">
                            <BiQrScan className="mr-2 mt-1" />
                            <p>Scan Serial No</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Add batching Modal */}
        <Modal
          open={batchingModal}
          title="Create New Batch"
          onOk={() => setBatchingModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setBatchingModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label flex">
                  Batch No <p className="text-[red] ml-1">*</p>
                </Typography>

                <Input
                  // name="toCollectAmount"
                  // value={partyData.toCollectAmount}

                  // onChange={(e) => handleChange(e)}

                  type="text"
                  className="p-2"
                  placeholder="Batch #1"
                />
              </Col>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Sales Price
                </Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  addonAfter={"With Tax"}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={"/PCS"}
                  type="text"
                  className="item-stock ml-[-5px]"
                  placeholder="Enter Sales Price"
                />
              </Col>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Purchase Price
                </Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}
                  addonAfter={"With Tax"}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={"/PCS"}
                  type="text"
                  className="item-stock  ml-[-5px]"
                  placeholder="Enter Purchase Price"
                />
              </Col>

              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  {" "}
                  Opening Stock
                </Typography>

                <Input
                  // name="toCollectAmount"
                  // value={partyData.toCollectAmount}
                  // onChange={(e) => handleChange(e)}

                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[4px] pl-[4px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder="0"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  As of Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  value={asOfDate}
                  onChange={(date, dateString) => {
                    if (dateString) {
                      setAsOfDate(dateString);
                    } else {
                      setAsOfDate("");
                    }
                  }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Select Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  Expiry Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  // value={asOfDate}
                  // onChange={(date, dateString, id) => {
                  //   console.log(date, dateString, id, "date");
                  //   if (dateString) {
                  //     setAsOfDate(dateString);
                  //   } else {
                  //     setAsOfDate("");
                  //   }
                  // }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Select Expiry Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  Mfg Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  // value={asOfDate}
                  // onChange={(date, dateString, id) => {
                  //   console.log(date, dateString, id, "date");
                  //   if (dateString) {
                  //     setAsOfDate(dateString);
                  //   } else {
                  //     setAsOfDate("");
                  //   }
                  // }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Manufacturing Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">Travel</Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}

                  type="text"
                  placeholder="Custom Value"
                />
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>
        {/* New category modal */}
        <Modal
          open={itemCategoryModal}
          title={"Create Category"}
          onOk={() => {
            createCategory();
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          width={450}
          onCancel={() => setItemCategoryModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "1px",
              width: "112%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mt-[-5px]">
            <Typography
              className="uppercase mb-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
            >
              Category Name
            </Typography>
            <Input
              name="categoryName"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Enter Category Name"
              className="p-2"
            />
            <p className="text-start text-[red] mt-2 mb-3">
              {simpleValidator.current.message(
                "categoryName",
                categoryName,
                "required"
              )}
            </p>
          </Col>
          {categoryAdditionalFields ? (
            <>
              {" "}
              <Col span={24} className="flex justify-end">
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => setCategoryAdditionalFields(false)}
                  className="cursor-pointer text-[#d54041] text-[13px]"
                >
                  Remove
                </div>
              </Col>
              <Col span={24}>
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Short Code
                </Typography>
                <Input
                  name="shortCode"
                  value={shortCode}
                  onChange={(e) => setShortCode(e.target.value)}
                  placeholder="Enter Short Code"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-[50px] mt-2">
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Description
                </Typography>
                <Input.TextArea
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                  className="p-3"
                />
              </Col>
            </>
          ) : (
            <div
              style={{
                fontFamily: "Poppins",
              }}
              onClick={() => setCategoryAdditionalFields(true)}
              className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
            >
              <PlusOutlined className="mr-2" /> Additonal Fields
            </div>
          )}
        </Modal>

        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);

            history.push("/purchase-orders");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
        {/* Purchase price Modal */}
        <Modal
          open={purchasePriceModal}
          title="Hide the Purchase price"
          onOk={() => {
            setPurchaseColumn(true);
            setPurchasePriceModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setPurchasePriceModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-4px",
            }}
          />

          <Col span={24} className="mb-10">
            <div className="">
              <Typography className="text-center text-[14px] purchase-label">
                Are you sure you want to hide the
              </Typography>
              <Typography className="text-center ml-2  purchase-label font-semibold text-[14px]">
                purchase price in Invoice .?
              </Typography>
            </div>
          </Col>
        </Modal>

        <CreateItems
          routeName="PurchaseOrders"
          modalOpen={createItemModal}
          modalClose={handleClose}
        />
      </Row>

      <Prompt
        when={!isEmpty(purchaseData) || !isEmpty(totalSectionData)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

CreatePurchaseOrders.propTypes = {
  onSignin: PropTypes.any,
  location: PropTypes.any,
  recordsMetaData: PropTypes.any,
};

export default CreatePurchaseOrders;
